import { createRequestTypes } from '../utils';

export const DASHBOARD_RESULT_LIST = createRequestTypes('dashboard/DASHBOARD_RESULT_LIST');
export const DASHBOARD_LIST = createRequestTypes('dashboard/DASHBOARD_LIST');
export const DASHBOARD = createRequestTypes('dashboard/DASHBOARD');
